// removed by extract-text-webpack-plugin
module.exports = {"LibraryHeader":"_15A8Aww-pXhqOfv6YK8Scy","LibraryHeader__fatSection":"_2rmkXqBPbRzq8b8GgTs5Eo","LibraryHeader__largeSearchBox":"_3Lf81vg27lJI4P1ZyLZ23M","LibraryHeader__searchTagsWithImages":"_1lzB5m3xlkQlkWHaaL4PvN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryHeader/LibraryHeader.scss
// module id = 2624
// module chunks = 0